import applicationLetter from "asset/onboarding/compliance/all-regions/4a2f66f6531d9ea5752ea867fad0c6b8dd85ebab.png";
import allRegionCertificate from "asset/onboarding/compliance/all-regions/6add62cbc8bcd0bf3cd5bf30fbeca0e75eb4a952.png";
import boardResolution from "asset/onboarding/compliance/all-regions/bcfcd2df78fa550e4aeac68007613d169d98ddb0.png";
import operatingAgreement from "asset/onboarding/compliance/all-regions/cf0db4ccc4f52ddb136947c23b92dfc541e6088d.png";
import middleEastBusinessLicense from "asset/onboarding/compliance/middle-east/30f97e876bf8abc749f9333dd56d55ed497df537.png";
import middleEastCommercialRegistration from "asset/onboarding/compliance/middle-east/6bbc08222d3eab9b6acda41db07b4f4327e5673b.png";
import nigeriaStatusReport from "asset/onboarding/compliance/nigeria/cac-status-report.png";
import nigeriaCac7Directors from "asset/onboarding/compliance/nigeria/4849cd268c2553075c4833d5e5de5d25a24f687c.png";
import nigeriaCertificate from "asset/onboarding/compliance/nigeria/673e182e2460411e20b5db41f3635d945d7affbc.png";
import nigeriaCac2ShareCapital from "asset/onboarding/compliance/nigeria/8678bc03a51d99ab8a083b36ab976e7320b59ef6.png";
import nigeriaCac3Address from "asset/onboarding/compliance/nigeria/d84b596cae10de4d1c174ca77e4bbcbd9f3231ac.png";
import nigeriaCac21Secretary from "asset/onboarding/compliance/nigeria/de4454c9dc1777775239767b42dc50615373a7fe.png";
import nigeriaMemorandumArticles from "asset/onboarding/compliance/nigeria/ed033535ea053ca36a20b25af2a714418dd07443.png";
import nigeriaCac4Compliance from "asset/onboarding/compliance/nigeria/ef78e5badb4ac33a8d6b94c1eec50cd72b620506.png";
import tenancyAgreement from "asset/onboarding/contact-details/4d697d29224b2ad0a66b9698ed7903364d59b33a.png";
import utilityBill from "asset/onboarding/contact-details/utility-bill.png";
import passport from "asset/onboarding/control-perosn-directors/20437a4f4701b6d170ba5ac36a86cad1b6b1de7d.png";
import driverLicense from "asset/onboarding/control-perosn-directors/3bb541297c2d26b59b8a70672298a3e7028b717b.png";
import nationalId from "asset/onboarding/control-perosn-directors/f922abc8553b4835a82ec9c1f7d2ce0618b264be.png";

export const onboardingSampleDocuments = {
    applicationLetter,
    allRegionCertificate,
    boardResolution,
    operatingAgreement,
    middleEastBusinessLicense,
    middleEastCommercialRegistration,
    nigeriaStatusReport,
    nigeriaCac7Directors,
    nigeriaCac2ShareCapital,
    nigeriaCac3Address,
    nigeriaCac21Secretary,
    nigeriaCac4Compliance,
    nigeriaCertificate,
    nigeriaMemorandumArticles,
    proofOfAddress: utilityBill,
    utilityBill,
    tenancyAgreement,
    passport,
    driverLicense,
    nationalId,
};

export const complianceSampleDocuments = {
    "Certificate of Incorporation": allRegionCertificate,
    "Certificate of Incorporation or Business License": allRegionCertificate,
    "Memorandum & Articles of Association": nigeriaMemorandumArticles,
    "Operating Agreement or Articles of Incorporation": operatingAgreement,
    "Commercial Registration Certificate": middleEastCommercialRegistration,
    "Trade/Business License": middleEastBusinessLicense,
    "Board resolution to open an account": boardResolution,
    "Board resolution to open an account with Tradevu": boardResolution,
    "Application letter to open an account with TradeVu": applicationLetter,
    "Application letter to open an account with Tradevu": applicationLetter,
    "CAC Status Report": nigeriaStatusReport,
    "CAC Forms (2, 2.1, 3, 4, and 7)": nigeriaCac2ShareCapital,
    "CAC Form 2": nigeriaCac2ShareCapital,
    "CAC Form 2.1": nigeriaCac21Secretary,
    "CAC Form 3": nigeriaCac3Address,
    "CAC Form 4": nigeriaCac4Compliance,
    "CAC Form 7": nigeriaCac7Directors,
    "CAC BN Form 1": nigeriaStatusReport,
};

export const getComplianceSampleDocuments = (country = "") => {
    const isNigeria = country === "Nigeria" || country === "NG";
    const certificate = isNigeria ? nigeriaCertificate : allRegionCertificate;

    return {
        ...complianceSampleDocuments,
        "Certificate of Incorporation": certificate,
        "Certificate of Incorporation or Business License": certificate,
    };
};

export const proofOfAddressSampleDocuments = {
    "Utility bill": utilityBill,
    "Recent utility bill": utilityBill,
    "Bank statement": utilityBill,
    "Tenancy agreement": tenancyAgreement,
    "Council tax bill": utilityBill,
    "Lease agreement": tenancyAgreement,
};

export const identificationSampleDocuments = {
    passport,
    Passport: passport,
    national_id: nationalId,
    nationalId,
    "National ID": nationalId,
    drivers_license: driverLicense,
    driversLicense: driverLicense,
    "Driver's License": driverLicense,
};

